import { initializePaddle, Paddle } from "@paddle/paddle-js";

let paddle: Paddle | undefined;

 
export const initialisePaddle = async () => {
  if (paddle) {
    return paddle;
  }

  const environment =
    process.env.NEXT_PUBLIC_APP_ENV === "production" ? "production" : "sandbox";

  paddle = await initializePaddle({
    environment,
    token: process.env.NEXT_PUBLIC_PADDLE_PUBLIC_KEY!,
    eventCallback: event => {
      if (event.name === "checkout.completed") {
        // TODO: ideally find a way to auto-login here

        window.location.href = "/login?activated=true";
      }
    },
  });
};

 
export const getPaddle = () => paddle;

 
export const openCheckout = (userId: string, email: string, priceId: string) =>
  paddle?.Checkout.open({
    settings: {
      allowLogout: false,
      showAddDiscounts: true,
      allowDiscountRemoval: true,
    },
    items: [{ priceId, quantity: 1 }],
    customer: { email },
    customData: { userId, email },
  });
